// extracted by mini-css-extract-plugin
export default {"Changelog":"index-module--Changelog--rbcnE","Changelog__title":"index-module--Changelog__title--SlvmQ","Changelog__link":"index-module--Changelog__link--jD4lf"};